// File: /var/www/app1/frontend/src/components/Login.js
// Updated for new auth system - Build: 2025-09-27-10:55

import React, { useState } from "react";
import axios from "axios";

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post("/api/auth/login", {
        username,
        password,
      });

      if (response.data.success) {
        onLogin({
          username: username,
          role: response.data.user.role,
        }, {
          accessToken: response.data.accessToken,
          refreshToken: response.data.refreshToken
        });
      }
    } catch (error) {
      setError(
        error.response?.data?.error || "Login failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Monthly Report System</h2>
        <h3>Login</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username / Worker Number:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="Enter username or worker number"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter password"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <div className="login-info">
          <p>
            <strong>Admin Login Only</strong>
          </p>
          <p>Use your admin credentials to access the system</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
